// Module
var code = "<h2 id=\"paid-ahead\">Paid Ahead</h2> <p>Learn how extra payments may affect your account status.</p> ";
// Exports
export default code;